var _defs, _rect, _rect2, _rect3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRankingStarTop = function SvgRankingStarTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ranking-star-top_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ranking-star-top_svg__a",
    x: 1.125,
    y: 15.75,
    width: 5.25,
    height: 7.5,
    rx: 0.75,
    ry: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ranking-star-top_svg__a",
    x: 17.625,
    y: 18.75,
    width: 5.25,
    height: 4.5,
    rx: 0.75,
    ry: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "ranking-star-top_svg__a",
    x: 9.375,
    y: 12.75,
    width: 5.25,
    height: 10.5,
    rx: 0.75,
    ry: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ranking-star-top_svg__a",
    d: "M12.905 1.076l1.249 2.455h2.127a.582.582 0 01.419 1l-1.953 1.918 1.082 2.485a.589.589 0 01-.839.737L12.375 8.2 9.76 9.671a.589.589 0 01-.839-.737L10 6.449 8.05 4.527a.582.582 0 01.419-1H10.6l1.249-2.455a.594.594 0 011.056.004z"
  })));
};

export default SvgRankingStarTop;